// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L3gr","label":"styles_label__1WpkJ"};